export enum CBTProgramWeekSixStep {
    HowDidCognitiveFlexibilityGoStep = 'how-did-cognitive-flexibility-go-last-week',
    WhyFocusOnBehaviorsStep = 'why-focus-on-behaviors',
    SomeRemindersStep = 'some-reminders',
    AvoidingEmotionsStep = 'avoiding-emotions',
    WhatAreYourBehaviorsStep = 'what-are-your-behaviors',
    WhyDoWeAvoidStep = 'why-do-we-avoid',
    WhatCanWeDoDifferentlyStep = 'what-can-we-do-differently',
    ExamplesStep = 'examples-of-alternative-behaviors',
    ThisSeemsDifficultStep = 'this-seems-difficult',
    ConsequencesStep = 'consequences',
}

export enum CBTProgramWeekSixSurvey {
    HowDidCognitiveFlexibilityGo = 'week-6-how-did-cognitive-flexibility-go',
    WhatAreYourBehaviors = 'week-6-what-are-your-behaviors',
    Consequences = 'week-6-consequences',
}
